import HowItWorksModalContent from './how_it_works_modal';
export default HowItWorksModalContent;
